import { Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useRef, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";
import { cmoMembersList } from "../../../containers/actions/pharmaCo/purchaseOrderActions";
import MandatorySpan from "../sasl/models/MandatorySpan";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";

// Sample data
// const data = {
//   forecastScheduleListForAuditUI: [
//     {
//       poNumber: 5100000676,
//       poDrugList: [
//         { drugName: "IMCL-986465", drugID: 1, collabrixForecastScheduleID: 92827262 },
//         { drugName: "IMCL-986466", drugID: 2, collabrixForecastScheduleID: 92827263 },
//         { drugName: "IMCL-986466", drugID: 2, collabrixForecastScheduleID: 92827266 },
//         { drugName: "IMCL-986467", drugID: 3, collabrixForecastScheduleID: 92827264 }
//       ]
//     },
//     {
//       poNumber: 5100000670,
//       poDrugList: [
//         { drugName: "IMCL-986369", drugID: 4, collabrixForecastScheduleID: 92827265 },
//         { drugName: "IMCL-986470", drugID: 5, collabrixForecastScheduleID: 92827266 },
//         { drugName: "IMCL-986471", drugID: 6, collabrixForecastScheduleID: 92827267 }
//       ]
//     }
//   ]
// };

const FilterBox = (props) => {
  const { handleSelectChange } = props;

  const dispatch = useDispatch();
  const [productList, setProductList] = useState([]);
  const [batchList, setBatchList] = useState([]);

  const [selectedCMO, setSelectedCMO] = useState(null);
  let previousCMO = useRef();

  const [selectedProduct, setSelectedProduct] = useState(null);
  let previousProduct = useRef();

  const [selectedBatch, setSelectedBatch] = useState(null);

  let cmoMemberWithId = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );

  useEffect(() => {
    let { collabType, ecosystemId, organizationName, roleName } = localStorage;
    if (collabType !== "CMO") {
      dispatch(
        cmoMembersList({
          collabType: collabType,
          roleName: roleName,
          organizationName: organizationName,
          ecosystemId: ecosystemId,
        })
      );
    }
  }, []);

  useEffect(() => {
    //console.log(selectedCMO);
    //console.log(selectedProduct);

    if (selectedCMO === null) {
      previousCMO.current = null;
      setProductList([]);
    }

    if (selectedProduct === null) {
      previousProduct.current = null;
      setBatchList([]);
    }

    if (selectedCMO !== null && previousCMO.current !== selectedCMO) {
      //console.log("Inside selected new CMO");
      previousCMO.current = selectedCMO;
      let data = {
        vendorMosymphonyID: selectedCMO.organization_id,
      };
      axios
        .post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchFilterDataForBackwardGenealogy`,
          data
        )
        .then((res) => {
          //console.log(res.data);
          if (res.data.status) {
            setProductList(res.data?.data ? res.data?.data : []);
          }
        })
        .catch((err) => {
          //console.log(err);
        });
      // setProductList([
      //   {
      //     fgMaterialCode: 10023456,
      //     fgMaterialName: "PROD A (10X15)",
      //     batchDetails: [
      //       {
      //         vendorBatchNumber: "BATCH001",
      //         batchSize: 50,
      //         batchUOM: "CARTON",
      //         statusDescription: "Approved",
      //         schrockenDeliveryScheduleBatchID: 10698,
      //         schrockenDeliveryScheduleID: 79788,
      //         bomConsumptionAddedIndicator: true,
      //         statusID: 1,
      //       },
      //       {
      //         vendorBatchNumber: "BATCH002",
      //         batchSize: 60,
      //         batchUOM: "CARTON",
      //         statusDescription: "Pending Approval",
      //         schrockenDeliveryScheduleBatchID: 10002,
      //         schrockenDeliveryScheduleID: 20002,
      //         bomConsumptionAddedIndicator: false,
      //         statusID: 2,
      //       },
      //     ],
      //   },
      //   {
      //     fgMaterialCode: 20034567,
      //     fgMaterialName: "PROD B (20X10)",
      //     batchDetails: [
      //       {
      //         vendorBatchNumber: "BATCH101",
      //         batchSize: 30,
      //         batchUOM: "BOX",
      //         statusDescription: "Under Quality Check",
      //         schrockenDeliveryScheduleBatchID: 30001,
      //         schrockenDeliveryScheduleID: 40001,
      //         bomConsumptionAddedIndicator: true,
      //         statusID: 3,
      //       },
      //       {
      //         vendorBatchNumber: "BATCH102",
      //         batchSize: 40,
      //         batchUOM: "BOX",
      //         statusDescription: "Awaiting Shipment",
      //         schrockenDeliveryScheduleBatchID: 30002,
      //         schrockenDeliveryScheduleID: 40002,
      //         bomConsumptionAddedIndicator: false,
      //         statusID: 4,
      //       },
      //     ],
      //   },
      //   {
      //     fgMaterialCode: 30045678,
      //     fgMaterialName: "PROD C (5X25)",
      //     batchDetails: [
      //       {
      //         vendorBatchNumber: "BATCH201",
      //         batchSize: 20,
      //         batchUOM: "PACK",
      //         statusDescription: "Approved",
      //         schrockenDeliveryScheduleBatchID: 50001,
      //         schrockenDeliveryScheduleID: 60001,
      //         bomConsumptionAddedIndicator: true,
      //         statusID: 1,
      //       },
      //       {
      //         vendorBatchNumber: "BATCH202",
      //         batchSize: 15,
      //         batchUOM: "PACK",
      //         statusDescription: "Pending Approval",
      //         schrockenDeliveryScheduleBatchID: 50002,
      //         schrockenDeliveryScheduleID: 60002,
      //         bomConsumptionAddedIndicator: false,
      //         statusID: 2,
      //       },
      //     ],
      //   },
      //   {
      //     fgMaterialCode: 40056789,
      //     fgMaterialName: "PROD D (30X5)",
      //     batchDetails: [
      //       {
      //         vendorBatchNumber: "BATCH301",
      //         batchSize: 25,
      //         batchUOM: "CARTON",
      //         statusDescription: "Awaiting CoA Approval",
      //         schrockenDeliveryScheduleBatchID: 70001,
      //         schrockenDeliveryScheduleID: 80001,
      //         bomConsumptionAddedIndicator: false,
      //         statusID: 3,
      //       },
      //       {
      //         vendorBatchNumber: "BATCH302",
      //         batchSize: 35,
      //         batchUOM: "CARTON",
      //         statusDescription: "Approved",
      //         schrockenDeliveryScheduleBatchID: 70002,
      //         schrockenDeliveryScheduleID: 80002,
      //         bomConsumptionAddedIndicator: true,
      //         statusID: 1,
      //       },
      //       {
      //         vendorBatchNumber: "BATCH303",
      //         batchSize: 40,
      //         batchUOM: "CARTON",
      //         statusDescription: "Under Quality Check",
      //         schrockenDeliveryScheduleBatchID: 70003,
      //         schrockenDeliveryScheduleID: 80003,
      //         bomConsumptionAddedIndicator: false,
      //         statusID: 4,
      //       },
      //     ],
      //   },
      // ]);
    }

    if (selectedProduct !== null && previousProduct !== selectedProduct) {
      console.log("Inside new product");
      previousProduct.current = selectedProduct;
      setBatchList(selectedProduct.batchDetails);
    }
  }, [selectedCMO, selectedProduct]);

  return (
    <Grid container spacing={2}>
      {/* PO Number Autocomplete */}
      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          options={cmoMemberWithId}
          name="cmo"
          getOptionLabel={(option) => `${option.organization_name}`}
          value={selectedCMO}
          onChange={(event, value) => {
            setSelectedCMO(value);
            setSelectedProduct(null);
            setSelectedBatch(null);
            handleSelectChange("cmo", value);
            handleSelectChange("productCodeDiscription", null);
            handleSelectChange("batchNumber", null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                <span>
                  Select CMO name <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputProps={{
                ...params.InputProps,
                startAdornment: <SearchIcon />,
              }}
            />
          )}
        />
      </Grid>
      {/* Drug ID Autocomplete */}
      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          name="productCodeDiscription"
          options={productList}
          getOptionLabel={(option) =>
            `${option.fgMaterialCode} / ${option.fgMaterialName}`
          }
          value={selectedProduct}
          onChange={(event, value) => {
            setSelectedProduct(value);
            setSelectedBatch(null);
            handleSelectChange("productCodeDiscription", value);
            handleSelectChange("batchNumber", null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                <span>
                  Select product code / description{" "}
                  <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputProps={{
                ...params.InputProps,
                startAdornment: <SearchIcon />,
              }}
            />
          )}
          disabled={!selectedCMO} // Disable until PO is selected
        />
      </Grid>
      {/* Forecast Schedule ID Autocomplete */}
      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          id="batchNumber"
          options={batchList}
          getOptionLabel={(option) => `${option.vendorBatchNumber}`}
          value={selectedBatch}
          onChange={(event, value) => {
            setSelectedBatch(value);
            handleSelectChange("batchNumber", value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                <span>
                  Select batch number <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputProps={{
                ...params.InputProps,
                startAdornment: <SearchIcon />,
              }}
            />
          )}
          disabled={!selectedProduct} // Disable until Drug is selected
        />
      </Grid>
    </Grid>
  );
};

export default FilterBox;
